module.exports = __webpack_public_path__ + "img/yellow-marker.8c9008cf.svg";